<template>
  <div class="pad">
    <div class="HeaderSection">
      <b-row>
        <b-col>
          <h2 class="FullScheduleTitle">
            {{ oomtitle || "Order Of Merit" }}
          </h2>
        </b-col>

        <b-col md="6" cols="12">
            <b-nav pills style="float:right">
                <b-dropdown :text="this.id + ' Season'">
                <b-dropdown-item
                    v-on:click="changeYear"
                    v-for="(seasons,
                    index) in tm_params.seasons.seasons_entry.slice().reverse()"
                    :key="index"
                    :title="seasons.code"
                    :year="seasons.code"
                    >{{ seasons.desc }}</b-dropdown-item
                >
                </b-dropdown>
            </b-nav>
        </b-col>
      </b-row>
    </div>

    <Oom
        :config="config"
        :tm_params="tm_params"
        :data="data"
        :id="id"
    />
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
import { Oom } from "@ocs-software/vue-ocs";

export default {
  name: "Order of Merit",
  props: ["config"],

  components: { Oom },

  data() {
    return {
    // data: [],
    // id: null,
    main_oom: null,
    // tm_params: {},
    oomtitle: "",
    oomcashType: "",
    loading: true,
    stats: [],
    id: this.$route.query.id,
    stat: "-ooms-oom-" + this.config.VUE_APP_OOM,
    data: [],
    tm_params: [],
    };
  },

  filters: {
    lowercase(value) {
      return value ? `${value.toLowerCase()}.svg` : "";
    }
  },
watch: {
  data(val) {
    console.log("PARENT data changed:", val);
  }
},
  methods: {
    changeYear: function(event) {
      var id = event.target.getAttribute("title");
      return (
        (this.id = id),
        apiCall
          .tmStats(this.id)
          .then(({ data }) => {
            this.stats = data;
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            throw error;
          }),
        apiCall
          .stat(this.id, this.stat)
          .then(({ data }) => {
            this.data = data;
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            throw error;
          })
      );
    },
    pickStat: function(event) {
      var stat = event.target.getAttribute("title");
      // var stat = 'RK';
      return (
        (this.stat = stat),
        apiCall
          .stat(this.id, this.stat)
          .then(({ data }) => {
            this.data = data;
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            throw error;
          })
      );
    },

    isMobile() {
      return screen.width <= 500;
    }
  },

  async mounted() {
    try {
      // First call, await for call to return
      let first_call = await apiCall.tmParamsBase();
      this.id = first_call.data.tm_params.season_code;
      this.tm_params = first_call.data;
      this.DEFIMAGESAMS3 = first_call.data.tm_params.DEFIMAGESAMS3;
      this.loading = false;
      // Second call, await for call to return
      let second_call = await apiCall.tmStats(this.id);
      this.stats = second_call.data;
      this.loading = false;
      // Third call, await for call to return
      let third_call = await apiCall.stat(this.id, this.stat);
      this.data = third_call.data;
      this.loading = false;
    } catch (error) {
      console.log("error in await calls");
      console.log(error);
      throw error;
    }
  },
};
</script>
<style scoped>
td.cut {
  color: #000;
  text-align: left;
}
tr.cutBK {
    background-color: #203EFF;
    color: #000;
}
.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0)!important;
}
.pad {
    padding: 2% 5%;
}
.sponsoredImage {
  width: 50px;
  margin-left: 10px;
}
::v-deep ul.nav.nav-pills.card-header-pills {
    float: right;
    margin-right: 0px;
}
::v-deep .dropdown-toggle:after {
    margin-left: 10px;
}
::v-deep .btn {
    background-color: #203EFF;
    border-color: rgb(255, 255, 255);
    font-size: 1rem;
    border-radius: 0px;
    width: 300px;
}
.HeaderSection {
    margin-top: 3em;
    margin-bottom: 2em;
}
.posCent {
    text-align: center;
}
.flag {
    width: 30px;
}
td {
    padding: 11px;
    vertical-align: top;
    border-top: 0 solid #dee2e6;
    font-size: 11pt;
    border: 0px!important;
}
::v-deep tr:nth-child(odd) {
    background: rgba(0,0,0,.05);
}
::v-deep .table-bordered thead th, .table-bordered thead td {
    border-bottom-width: 0px;
}
::v-deep .fields {
    background-color: #203EFF!important;
}
::v-deep thead {
    /* background: pink; */
    /* color: #fff; */
    background-color: #1a2337;
    color: #fff!important;
    padding-bottom: 10px;
    font-size: 10pt;
    font-weight: 100!important;
}
th {
    font-weight: 400;
}
::v-deep .table-bordered th, .table-bordered td {
    border: 0px solid #dee2e6!important;
}
.table-bordered {
    border: 0px solid #dee2e6;
}
</style>